export default "__VITE_ASSET__xYwJuORU__"